import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Apple, Facebook, Vkontakte, WechatRing } from '@ori-ui/icons';
import { ButtonBase, styled, SHADOW_LEVEL1, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { useTranslation } from 'react-i18next';
import { DESKTOP_BREAKPOINT } from '../../../constants';
import { useSocialMediaContext } from '../../../contexts/SocialMediaContext';
import { SocialMediaPlatforms, SocialMediaProviders } from '../../../models';
import { LocalizationKeys } from '../../../models/localizationKeys';
import { GoogleIcon } from './GoogleIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SocialMediaRoot = styled('div')({
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'left'
});
var SocialMediaForm = styled('form')(function (_ref) {
  var theme = _ref.theme;
  return {
    borderRadius: 20,
    boxShadow: SHADOW_LEVEL1,
    height: 40,
    marginTop: theme.spacing(2)
  };
});
var SocialMediaFormLogin = styled(ButtonBase)(function (_ref2) {
  var theme = _ref2.theme,
      ownerState = _ref2.ownerState;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    fontSize: theme.typography.h3.fontSize,
    height: '100%',
    width: '100%'
  }, ownerState.mediaProviderName === 'facebook' && {
    color: '#1877f2'
  }), ownerState.mediaProviderName === 'vkontakte' && {
    color: '#44668f'
  }), ownerState.mediaProviderName === 'wechat' && {
    color: '#2cbb00'
  }), ownerState.mediaProviderName === 'apple' && {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(35)
  });
});
var SocialMediaFormContent = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  width: '100%'
});
var SocialMediaFormIcon = styled('div')({
  margin: '7px 0 0 5px',
  width: 40
});
var SocialMediaFormLabel = styled(Typography)(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
    margin: theme.spacing(0, 'auto'),
    overflowWrap: 'break-word'
  }, theme.breakpoints.down(DESKTOP_BREAKPOINT), {
    marginLeft: 48
  });
});

var getSocialMediaIcon = function getSocialMediaIcon(mediaProviderName) {
  switch (mediaProviderName) {
    case SocialMediaPlatforms.Facebook:
      return /*#__PURE__*/_jsx(Facebook, {
        fontSize: "inherit"
      });

    case SocialMediaPlatforms.Google:
      return /*#__PURE__*/_jsx(GoogleIcon, {});

    case SocialMediaPlatforms.VKontakte:
      return /*#__PURE__*/_jsx(Vkontakte, {
        fontSize: "inherit"
      });

    case SocialMediaPlatforms.Wechat:
      return /*#__PURE__*/_jsx(WechatRing, {
        fontSize: "inherit"
      });

    case SocialMediaPlatforms.Apple:
      return /*#__PURE__*/_jsx(Apple, {
        fontSize: "inherit"
      });

    default:
      return null;
  }
};

var getSocialMediaTranslation = function getSocialMediaTranslation(mediaProviderName) {
  switch (mediaProviderName) {
    case SocialMediaPlatforms.Facebook:
      return LocalizationKeys.facebookContinueWith.id;

    case SocialMediaPlatforms.Google:
      return LocalizationKeys.googleAccountContinueWith.id;

    case SocialMediaPlatforms.VKontakte:
      return LocalizationKeys.vKontakteContinueWith.id;

    case SocialMediaPlatforms.Wechat:
      return LocalizationKeys.weChatContinueWith.id;

    case SocialMediaPlatforms.Apple:
      return LocalizationKeys.appleContinueWith.id;

    default:
      return LocalizationKeys.continue.id;
  }
};

export var SocialMedia = function SocialMedia() {
  var _useTranslation = useTranslation(),
      _useTranslation2 = _slicedToArray(_useTranslation, 1),
      translate = _useTranslation2[0];

  var _useSocialMediaContex = useSocialMediaContext(),
      allowedExternalProviders = _useSocialMediaContex.allowedExternalProviders;

  var _useTestId = useTestId(),
      getTestId = _useTestId.getTestId;

  if (!allowedExternalProviders || allowedExternalProviders.length === 0) {
    return null;
  }

  return /*#__PURE__*/_jsx(SocialMediaRoot, {
    "data-testid": getTestId('social-wrapper'),
    children: allowedExternalProviders.map(function (_ref5) {
      var descriptionWithName = _ref5.Description,
          externalProvider = _ref5.ExternalProvider;
      var mediaProviderName = Object.keys(SocialMediaProviders).find(function (socialName) {
        return descriptionWithName.toLowerCase().includes(socialName.toLowerCase());
      });
      var ownerState = {
        mediaProviderName: mediaProviderName === null || mediaProviderName === void 0 ? void 0 : mediaProviderName.toLowerCase()
      };

      if (!mediaProviderName || mediaProviderName.toLowerCase() === 'activedirectory') {
        return null;
      }

      return /*#__PURE__*/_jsx(SocialMediaForm, {
        method: "post",
        action: "/system/ajax/LoginApi/LoginWithExternalProvider?externalProviderType=".concat(externalProvider),
        "data-testid": getTestId("social-".concat(mediaProviderName.toLowerCase())),
        children: /*#__PURE__*/_jsx(SocialMediaFormLogin, {
          disableRipple: true,
          ownerState: ownerState,
          type: "submit",
          children: /*#__PURE__*/_jsxs(SocialMediaFormContent, {
            children: [/*#__PURE__*/_jsx(SocialMediaFormIcon, {
              children: getSocialMediaIcon(mediaProviderName.toLowerCase())
            }), /*#__PURE__*/_jsx(SocialMediaFormLabel, {
              variant: "caption",
              children: translate(getSocialMediaTranslation(mediaProviderName.toLowerCase()))
            })]
          })
        })
      }, externalProvider);
    })
  });
};